import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 0 10px 0;
  padding: 10px 20px;
  height: 100%;
  gap: 20px;
  min-width: 250px;
`;
